module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.30657",
      "ably": "static-2.2",
      "ably-hubspot-js": "static-2.5036",
      "atom": "static-1.5400",
      "client-types": "static-1.498",
      "conversations-error-reporting": "static-1.9207",
      "conversations-internal-pub-sub": "static-1.16304",
      "conversations-internal-schema": "static-1.13415",
      "conversations-message-history": "static-1.13568",
      "conversations-test-sdk": "static-1.10817",
      "conversations-visitor-experience-components": "static-1.24020",
      "data-fetching-client": "static-1.9970",
      "head-dlb": "static-1.5007",
      "hs-promise-utils": "static-1.5908",
      "hs-test-utils": "static-1.8346",
      "hubspot-dlb": "static-2.1882",
      "HubStyleTokens": "static-2.11803",
      "I18n": "static-7.1675",
      "immer": "static-1.101",
      "jasmine-immutable": "static-1.3335",
      "jasmine-runner": "static-1.6765",
      "quartz": "static-1.7472",
      "react-dlb": "static-1.89",
      "react-select-plus": "static-1.113",
      "react-transition-group": "static-2.73",
      "redux-thunk": "static-2.80",
      "reselect": "static-3.12",
      "sanitize": "static-1.4786",
      "StyleGuideUI": "static-3.503",
      "transmute": "static-2.97",
      "urlinator": "static-1.4846",
      "usage-tracker": "static-1.7637",
      "usage-tracker-core": "static-1.7487",
      "usage-tracker-public": "static-1.7448",
      "viral-links-lib": "static-1.7390",
      "visitor-ui-component-library": "static-1.6463",
      "webpack-env": "static-1.54",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.5124",
      "conversations-prop-types": "static-1.7773",
      "conversations-visitor-message-history": "static-1.22757",
      "cssUtils": "static-1.935",
      "enviro": "static-4.455",
      "flux-actions": "static-1.369",
      "foundations-components": "static-1.8508",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.6528",
      "interactive-cards": "static-1.377",
      "hubspot-url-utils": "static-1.4297",
      "immutable": "static-2.83",
      "metrics-js": "static-1.9867",
      "PatternValidationJS": "static-1.3207",
      "PortalIdParser": "static-2.404",
      "pulse": "static-1.943",
      "raven": "static-3.5925",
      "react": "static-7.196",
      "react-aria": "static-1.72",
      "react-dom": "static-7.85",
      "react-redux": "static-7.75",
      "react-rhumb": "static-1-fkhalid-fix-is-reload-in-web-vitals-adapter.6",
      "react-utils": "static-2.5563",
      "redux": "static-4.76",
      "rpc-client-utils": "static-1.4979",
      "redux-toolkit": "static-1.78",
      "sanitize-text": "static-1.8469",
      "signup-constants": "static-1.19642",
      "styled-components": "static-2.95",
      "usage-tracker-multi": "static-1.6051",
      "visitor-ui-component-library-icons": "static-1.6274",
      "hs-promise-rejection-tracking": "static-1.5587",
      "raven-hubspot": "static-1.6232",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.3628",
      "moment": "static-3.75",
      "quartz-config": "static-1.1250",
      "quartz-core": "static-1.6691",
      "foundations-assets": "static-1.5198",
      "foundations-theming": "static-1.4789",
      "UIComponents": "static-3.8749",
      "conversations-async-data": "static-2.7982",
      "customer-data-email": "static-1.18538",
      "cv-backend-services": "static-1.1597",
      "immutable-less": "static-1.4963",
      "conversations-skeleton-state": "static-1.7560",
      "crm-events-viz-core": "static-1.34079",
      "customer-data-objects": "static-1.8006",
      "icons": "static-2.685",
      "react-input-autosize": "static-2.17",
      "react-performance-metrics-lib": "static-1.868",
      "ui-images": "static-2.1251",
      "apollo-stack-hubspot": "static-3.94",
      "fast-json-stable-stringify": "static-1.4",
      "graphql": "static-1.89",
      "HeadJS": "static-2.798",
      "framer-motion": "static-1.79",
      "hs-test-utils-bend-plugin": "static-1.3457",
      "msw": "static-1.39",
      "testing-library": "static-1.158",
      "i18n-data": "static-1.229",
      "moment-timezone": "static-5.91",
      "jasmine": "static-4.4626",
      "signup-ui-url-generator": "static-2.8374",
      "HubStyle": "static-2.12110",
      "quartz-i18n": "static-1.1147",
      "sassPrefix": "static-1.205",
      "bend-plugin-foundations-components": "static-1.4777",
      "floating-ui": "static-1.63",
      "foundations-theming-specialty": "static-1.2505",
      "hs-story-utils": "static-1.9737",
      "react-create-root-preference": "static-1.72",
      "react-virtualized": "static-2.107",
      "tanstack-table": "static-1.61",
      "trellis-assets": "static-1.2671",
      "ui-fonts": "static-1.1065",
      "hs-locale-management": "static-1.301",
      "dompurify": "static-1.8",
      "bend-plugin-pulse": "static-1.446",
      "batch-promise": "static-1.1857",
      "chirp-fetch": "static-1.2207",
      "event-emitter": "static-1.1266",
      "fast-json-patch": "static-1.70",
      "hub-http-janus": "static-1.882",
      "quick-fetch": "static-1.4136",
      "csstype": "static-1.50",
      "quartz-head": "static-1.1137",
      "web-vitals": "static-1.15",
      "bend-plugin-chirp-manifest": "static-1.389",
      "quartz-routing": "static-1.902",
      "usage-tracker-anonymous": "static-1.6054",
      "bender-build-tools": "static-1.3444",
      "opentelemetry-fe-types": "static-1.85",
      "dispatcher": "static-1.143",
      "general-store": "static-6.20",
      "hubspotter-http": "static-1.4870",
      "mobile-manifest-mixins": "static-1.578",
      "module-federation": "static-1.33",
      "opentelemetry-fe": "static-1.460",
      "quartz-auth": "static-1.1147",
      "quartz-test": "static-1.1147",
      "quartz-tracking": "static-1.851",
      "trellis-components": "static-1.2690",
      "usage-tracker-container": "static-1.7627",
      "bend-plugin-foundations-theming": "static-1.3272",
      "foundations-theming-base": "static-1.3774",
      "stylex": "static-1.41",
      "react-immutable-proptypes": "static-2.8",
      "apollo-dlb": "static-3.86",
      "apollo-link-hub-http": "static-2.4969",
      "customer-data-ui-utilities": "static-1.10143",
      "FileManagerCore": "static-1.40017",
      "FileManagerLib": "static-1.40158",
      "hubspot-apollo-client": "static-1.5190",
      "react-immutable-render-mixin": "static-1.9",
      "salesImages": "static-1.576",
      "timezone-utils": "static-2.5557",
      "ui-gdpr-components": "static-1.10625",
      "ts-schema": "static-1.4301",
      "ai-components-ui-library": "static-1.9736",
      "avatar-components": "static-1.2795",
      "content-assistance-lib": "static-1.8211",
      "crm-component-utils": "static-1.39855",
      "crm-display-components": "static-1.25605",
      "crm-fe-perf": "static-1.23215",
      "crm-links": "static-1.6643",
      "crm-message-bus": "static-1.43783",
      "crm-search-service-types": "static-1.1469",
      "crm-source-interpretation-lib": "static-1.5643",
      "customer-data-communicator": "static-1.46358",
      "customer-data-filters-ui": "static-1.40956",
      "customer-data-objects-ui-components": "static-1.13343",
      "customer-data-properties": "static-1.52627",
      "customer-data-rte": "static-1.33660",
      "draft-plugins": "static-2.22169",
      "file-manager-components": "static-1.24518",
      "trellis-theming": "static-1.1288",
      "framework-data-schema-resolvers": "static-1.7205",
      "frontend-preferences-client": "static-1.8235",
      "hubspot-prosemirror": "static-1.18985",
      "object-comments-thread-lib": "static-1.11348",
      "prosemirror-user-and-team-at-mentions": "static-1.1211",
      "reference-resolvers-lite": "static-1.8416",
      "ui-addon-upgrades": "static-9.18398",
      "universal-associations-select": "static-1.11391",
      "universal-record-utils-lib": "static-1.1978",
      "wootric-nps": "static-1.7207",
      "inbound-db-properties-service-client": "static-1.4062",
      "property-translator": "static-1.5709",
      "segments-query-core": "static-1.1737",
      "stylex-utils": "static-1.142",
      "opentelemetry-web": "static-1.13",
      "hub-http-shared-msw-handlers": "static-1.10634",
      "hubspotter-http-shared-msw-handlers": "static-1.10632",
      "usage-tracker-session-replay": "static-1.5323",
      "base-ui": "static-1.22",
      "react-day-picker": "static-1.10",
      "tanstack-virtual": "static-1.38",
      "react-dnd-compat": "static-1.4930",
      "breeze-artifacts-sdk": "static-1.368",
      "copilot-toolkit": "static-1.11861",
      "audio-components": "static-1.6356",
      "ContentUtils": "static-1.69138",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.29824",
      "FileManagerImages": "static-1.37669",
      "html-to-image": "static-1.61",
      "immerable": "static-1.4461",
      "react-colorpicker": "static-2.10530",
      "ui-universal-auth": "static-1.9422",
      "video-components": "static-1.14163",
      "video-data-lib": "static-1.35819",
      "video-embed": "static-1.36653",
      "hubspot-apollo-cache": "static-1.649",
      "chatspot-core": "static-1.23068",
      "superstore": "static-1.5071",
      "ui-addon-video-player": "static-1.9017",
      "ui-coaching-tips": "static-1.29323",
      "card-properties-lib": "static-1.45027",
      "commerce-subscription-lib": "static-1.37798",
      "crm-actions": "static-1.6664",
      "crm-cards-sdk": "static-1.44596",
      "customer-data-properties-shared-msw-handlers": "static-1.9961",
      "customer-data-property-utils": "static-1.8414",
      "customer-data-tracking": "static-1.7196",
      "hs-resources": "static-1.505",
      "inbound-db-meta-service-client": "static-1.3718",
      "framework-data-table": "static-2.12565",
      "location-customization-utils-lib": "static-1.10114",
      "restore-request-side-panel-lib": "static-1.1693",
      "calling-error-reporting": "static-1.31641",
      "calling-internal-common": "static-1.31634",
      "calling-usage-tracker": "static-1.6849",
      "crm_data": "static-4.92847",
      "customer-data-content": "static-1.27818",
      "draft-content-plugins": "static-1.28917",
      "draft-convert": "static-2.80",
      "draft-extend": "static-3.83",
      "draft-js": "static-5.85",
      "draft-signature-plugin": "static-1.24729",
      "EmailSignatureEditor": "static-1.25014",
      "hubspot-prosemirror-plugins": "static-1.18977",
      "integration-settings-components": "static-1.16225",
      "integrations-lib": "static-1.17056",
      "integrations-tracking-lib": "static-1.5921",
      "native-integrations-shared-strings": "static-1.8090",
      "nav-meta": "static-1.30487",
      "onboarding-scopes": "static-1.6765",
      "outreach-assistant-email-generation": "static-1.6828",
      "prosemirror": "static-1.13",
      "prosemirror-copilot": "static-1.12328",
      "quotes-client-types": "static-1.38940",
      "reference-resolvers": "static-1.8494",
      "rich-text-lib": "static-1.20318",
      "sales-email-signature-service-client": "static-1.4158",
      "sequences-lib": "static-1.8544",
      "ui-addon-i18n": "static-1.11461",
      "ui-addon-iframeable": "static-1.9392",
      "ui-business-units-lib": "static-1.9402",
      "ui-shepherd-react": "static-3.10584",
      "user-context": "static-1.5433",
      "whatsapp-sending-lib": "static-1.6781",
      "customer-data-filters-ui-msw-helpers": "static-1.23391",
      "customer-data-reference-ui-components": "static-1.13490",
      "events-data-lib": "static-1.559",
      "FormUrlGenerator": "static-2.5041",
      "framework-builder-read-service-client": "static-1.4228",
      "multi-account-reference-resolvers": "static-1.1318",
      "onboarding-tours": "static-1.17132",
      "reporting-datasets-permissions-lib": "static-1.14481",
      "SharedI18nStrings": "static-1.183",
      "ui-addon-teams": "static-1.21920",
      "calling-global-api": "static-1.65647",
      "calling-lifecycle-internal": "static-1.67029",
      "calling-lifecycle-messages": "static-1.59323",
      "commerce-products-lib": "static-1.10547",
      "conditional-properties-service-client": "static-1.4021",
      "crm-index-visualization-core": "static-1.4554",
      "crm-pipelines-api-client-types": "static-1.4355",
      "external-options-client-types": "static-1.4345",
      "formula-editor": "static-1.14781",
      "google-libphonenumber": "static-1.45",
      "inbounddb-objects-service-types": "static-1.4435",
      "meetings-icalendar-utils-lib": "static-1.950",
      "multi-currency-client-types": "static-1.3916",
      "object-builder-ui-client": "static-1.49696",
      "pipeline-validation-client-types": "static-1.4189",
      "property-value-citations": "static-1.3241",
      "smart-data-capture-core": "static-1.156",
      "smart-property-lib": "static-1.8313",
      "tiered-pricing": "static-1.1968",
      "topics-actions-lib": "static-1.480",
      "trial-components-library": "static-1.14119",
      "ui-addon-form-validation": "static-1.11295",
      "zustand": "static-1.85",
      "breeze-engine-lib": "static-1.1766",
      "video-components-external": "static-1.12161",
      "fdsr-migration-layer": "static-1.324",
      "framework-data-schema-quick-fetch": "static-1.7110",
      "persist-promise": "static-1.4014",
      "content-media-capture": "static-1.5457",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.26199",
      "knowledge-content-types": "static-1.8656",
      "payment-link-components": "static-1.24184",
      "ui-addon-emoji-picker": "static-1.10199",
      "call-summary": "static-1.40337",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.10780",
      "laboratory-lib": "static-3.7466",
      "merchandise-lib": "static-1.278",
      "purchase-motions-components": "static-1.6378",
      "crm-object-search-query-utilities": "static-1.10204",
      "amplitude-session-replay-browser": "static-1.60",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "magpie-lib": "static-1.5765",
      "magpie-types": "static-1.5225",
      "simple-logging-lib": "static-1.3364",
      "foundations-components-legacy": "static-1.1533",
      "cms-field-types": "static-1.5128",
      "content-icons-ui": "static-1.2376",
      "underscore": "static-1.8",
      "unified-auth-core-lib": "static-1.1218",
      "social-insights-client-types": "static-1.22706",
      "outpost": "static-1.4467",
      "markdown-it": "static-1.6",
      "growth-onboarding-feedback-components": "static-1.6897",
      "customer-data-sidebar": "static-2.46752",
      "enrichment-lib": "static-1.414",
      "ui-addon-draggable-compat": "static-2.4577",
      "commerce-billing-lib": "static-1.20204",
      "commerce-shared-components-lib": "static-1.19235",
      "commerce-tools-ui-lib": "static-1.11059",
      "customer-data-associations": "static-1.7640",
      "tasks-actions-lib": "static-1.145",
      "reporting-data": "static-1.68855",
      "ui-addon-draggable": "static-3.5074",
      "crm-record-cards-service-types": "static-1.3793",
      "crm_universal": "static-1.22508",
      "SalesContentIndexUI": "static-3.9633",
      "content-embed-lib": "static-1.7650",
      "data-model-builder-lib": "static-1.13168",
      "remote-dom": "static-1.4",
      "remote-ui": "static-1.71",
      "ui-components-test-utils": "static-1.5940",
      "ui-extensions-remote-renderer": "static-1.17905",
      "universal-page-editor-lib": "static-1.3322",
      "integrations-error-boundary-lib": "static-1.14471",
      "redux-observable": "static-1.75",
      "ReduxMessenger": "static-2.10684",
      "rxjs": "static-5.10",
      "unified-auth": "static-1.936",
      "messaging-types-lib": "static-1.46900",
      "ai-addon-copilot-preview": "static-1.8948",
      "data-token-picker": "static-1.16902",
      "sequences-client-types-lib": "static-1.8401",
      "foundations-components-test-utils": "static-1.5991",
      "navigation-messaging": "static-1.8177",
      "getting-started-shared-tasks": "static-1.19258",
      "getting-started-shared-tasks-store": "static-1.18376",
      "onboarding-tours-utils": "static-1.1199",
      "messaging-usage-based-billing-components-lib": "static-1.2025",
      "marketing-platform-lib": "static-1.7183",
      "whatsapp-management-lib": "static-1.9940",
      "growth-data-modal": "static-1.5909",
      "growth-onboarding-confetti": "static-1.3374",
      "growth-onboarding-next-action-utils": "static-1.2703",
      "navigation-components": "static-1.18850",
      "onboarding-tours-client": "static-1.5347",
      "ui-shepherd-tracker": "static-1.7965",
      "shared-worker-versioning": "static-1.11355",
      "voice-sms-access-library": "static-1.2078",
      "commerce-permissions": "static-1.1091",
      "products-iframe-lib": "static-1.8607",
      "products-ui-components-shared-msw-handlers": "static-1.11016",
      "crm-index-associations-lib": "static-1.6754",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10717",
      "sales-views-client-types": "static-1.4569",
      "bark-lib": "static-1.16826",
      "browser-prettier": "static-1.11",
      "codemirror": "static-5.102",
      "crm-properties-common-lib": "static-1.6202",
      "react-codemirror": "static-1.10955",
      "data-agent-kit": "static-1.662",
      "fsm": "static-1.4064",
      "policy-lib": "static-1.7115",
      "embedded-academy-lib": "static-1.15549",
      "hubs-service-types": "static-1.1572",
      "purchase-motions-api": "static-1.6381",
      "breeze-engine-chat-components": "static-1.744",
      "breeze-engine-core": "static-1.1044",
      "highlight.js": "static-1.86",
      "content-media-composition-data-lib": "static-1.13261",
      "content-media-compositions": "static-2.17268",
      "idb-keyval": "static-1.51",
      "media-bridge-lib": "static-1.19419",
      "fix-webm-duration": "static-1.30",
      "notification-sounds": "static-1.4739",
      "seat-types-lib": "static-1.747",
      "ui-addon-opt": "static-4.8677",
      "commerce-tours-lib": "static-1.6629",
      "growth-onboarding-reliability": "static-1.5395",
      "sales-checkout-service-client": "static-1.3842",
      "calling-lifecycle-usage-tracker": "static-1.9397",
      "reactive-lib": "static-1.1031",
      "card-payment-highlight-lib": "static-1.37997",
      "commerce-contract-lib": "static-1.13353",
      "invoices-highlight-card-lib": "static-1.55787",
      "orders-highlight-card-lib": "static-1.22210",
      "products-highlight-card-lib": "static-1.18830",
      "quotes-highlight-card-lib": "static-1.72850",
      "data-agent-utils": "static-1.476",
      "usage-based-billing-components-lib": "static-1.10292",
      "utility-belt": "static-1.2846",
      "payments-enrollment-embed-lib": "static-1.23866",
      "stripe-embedded-components": "static-1.8010",
      "growth-onboarding-empty-states": "static-1.6289",
      "InboxConnectUtils": "static-4.15573",
      "payments-post-enroll-local-storage-lib": "static-1.5418",
      "qrcode-generator": "static-1.76",
      "reporting-client-types": "static-1.2697",
      "react-flip-move": "static-1.78",
      "FireAlarmUi": "static-1.4729",
      "sales-templates-service-types-lib": "static-1.4391",
      "ui-asset-management-lib": "static-1.11411",
      "association-settings-lib": "static-1.11031",
      "collaboration-sidebar": "static-1.58737",
      "conditional-property-settings-components": "static-1.261",
      "conditional-property-settings-modal": "static-1.13172",
      "data-model-commons-lib": "static-1.13396",
      "ExportDialog": "static-6.10690",
      "final-form": "static-1.78",
      "nudge-client-utils": "static-1.3155",
      "property-management-iframe": "static-1.14145",
      "property-usages-lib": "static-1.5817",
      "reactflow": "static-1.71",
      "simple-data-table": "static-1.3538",
      "used-in-list-lib": "static-1.7278",
      "visual-association": "static-1.6204",
      "highcharts": "static-8.111",
      "reporting-visualizations": "static-1.60930",
      "ui-extensibility-client-types": "static-1.4232",
      "adobe-sign-auth-lib": "static-1.477",
      "ads-unified-auth-lib": "static-1.1444",
      "generic-oauth-auth-lib": "static-1.64",
      "google-sheets-integration-lib": "static-1.1044",
      "microsoft-drive-auth-lib": "static-1.160",
      "surveymonkey-integration-lib": "static-1.503",
      "slack-ui-library": "static-1.10712",
      "automation-platform-service-types": "static-1.2663",
      "ContentData": "static-1.69213",
      "email-portal-health-service-types": "static-1.1293",
      "marketing-email-service-types": "static-1.2102",
      "ai-rendering-library": "static-1.11116",
      "ai-settings-ui-library": "static-1.8363",
      "breeze-engine-ui-devtools": "static-1.140",
      "messaging-shared-utils-lib": "static-1.1474",
      "messaging-user-info-utils-lib": "static-1.1644",
      "content-whatsapp-service-types": "static-1.578",
      "short-messages-app-service-client": "static-1.4229",
      "ui-tool-access": "static-1.10468",
      "onboarding-data-sync-lib": "static-1.2525",
      "growth-onboarding-next-action-components": "static-1.2731",
      "user-context-client": "static-1.4819",
      "nest": "static-1.549",
      "calling-orchestration-schema": "static-1.36855",
      "diff-match-patch": "static-1.7",
      "react-reducer-toolkit": "static-1.16380",
      "browser-eslint": "static-2.57",
      "trellis-story-utils": "static-1.4821",
      "storybook-react": "static-1.40",
      "academy-common-lib": "static-1.15009",
      "js-cookie": "static-1.18",
      "products-ui-components": "static-1.41065",
      "settings-ui-lib": "static-1.12838",
      "accounting-integrations-ui-components": "static-1.7550",
      "invoices-ui-lib": "static-1.55803",
      "commerce-products-api": "static-1.2704",
      "invoices-iframe-lib": "static-1.57861",
      "quotes-modal-lib": "static-1.103528",
      "quotes-ui-lib": "static-1.81571",
      "one-click-checkout": "static-1.431",
      "platform-infra-nav-components": "static-1.7900",
      "reporting-ui-components": "static-2.66125",
      "subscription-experience-data-types": "static-1.15252",
      "marketplace-ui-apps-core": "static-1.19282",
      "stripe-connect-js": "static-1.76",
      "ui-addon-react-router-dom": "static-1.9848",
      "hub-http-contrib": "static-1.3352",
      "ui-addon-sales-email": "static-1.5526",
      "nested-table": "static-1.547",
      "chatspot-widget-iframe": "static-1.23059",
      "collaboration-sidebar-common": "static-1.3534",
      "conditional-property-settings-data": "static-1.279",
      "nudge-custom-function-registry": "static-1.2912",
      "nudge-renderer-utils": "static-1.3231",
      "whisper-core-api": "static-1.7340",
      "property-management-common": "static-1.6433",
      "d3": "static-1.7",
      "advanced-menus-core": "static-1.15590",
      "advanced-menus-lib": "static-1.12464",
      "ui-memberships-settings-lib": "static-1.34859",
      "breeze-onboarding-components": "static-1.751",
      "global-styles-ai-lib": "static-1.154",
      "marketplace-embed-ba": "static-1.635",
      "mermaid": "static-1.3",
      "reporting-action-components": "static-1.42066",
      "reporting-snowflake": "static-1.57472",
      "upgrade-components-lib": "static-1.533",
      "meetings-connect-utils-lib": "static-1.7922",
      "academy-service-client": "static-1.4002",
      "croppie": "static-2.10",
      "SafeStorage": "static-1.4717",
      "trellis-ecosystem": "static-1.7641",
      "commerce-tax-lib": "static-1.852",
      "price-books-api": "static-1.1750",
      "price-books-components": "static-1.1808",
      "property-description-translator": "static-1.4152",
      "ramp-editor": "static-1.902",
      "commerce-analytics-service-client": "static-1.3830",
      "totals-ui-components": "static-1.24306",
      "checkout-sdk": "static-3.24369",
      "payment-method-components": "static-1.7163",
      "touchless-buying-components": "static-1.6237",
      "upgrade-catalog-service-types": "static-1.3783",
      "reporting-plugins": "static-1.10768",
      "reporting-reports": "static-1.68532",
      "edison-service-client-types": "static-1.706",
      "developer-experience-shared-components": "static-1.10854",
      "marketplace-ui-client-types": "static-1.18157",
      "marketplace-ui-common": "static-1.20750",
      "ui-addon-integrations-directory-panel": "static-2.8340",
      "react-window": "static-1.13",
      "ts-utils-lib": "static-1.463",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.15589",
      "simple-menus-lib": "static-1.17106",
      "onboarding-journeys-lib": "static-1.932",
      "marketplace-embed": "static-1.22932",
      "marketplace-ui-install": "static-1.736",
      "marketplace-ui-tracking": "static-1.14920",
      "dashboard-lib": "static-1.82867",
      "share-with-third-party-component-lib": "static-1.9021",
      "line-items-api": "static-1.1108",
      "commerce-totals-service-types": "static-1.4038",
      "hub-http-rxjs": "static-1.846",
      "normalizr": "static-3.9",
      "ramda": "static-1.7",
      "billing-payments-client-types": "static-1.4304",
      "company-details-components": "static-1.6517",
      "emoji-regex": "static-1.7",
      "pricing-pages-ui-components": "static-1.15844",
      "quote-checkout-service-types": "static-1.3768",
      "campaign-roi-lib": "static-1.10288",
      "campaigns-utils-lib": "static-1.3531",
      "ui-addon-calendars": "static-2.5647",
      "apps-service-types": "static-1.4053",
      "oauth-service-types": "static-1.4549",
      "ui-product-approvals-common": "static-1.1094",
      "connections-embed-lib": "static-1.1525",
      "fail-safe": "static-1.267",
      "ai-studio-lib": "static-1.12450",
      "integrations-reconnect-lib": "static-1.498",
      "ui-product-approvals": "static-1.29199",
      "redux-actions": "static-3.70",
      "company-details-service-types": "static-1.4253",
      "pricing-pages-api": "static-1.15709",
      "bend-plugin-fail-safe": "static-1.218"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.30657",
      "ably": "/ably/static-2.2",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.5036",
      "atom": "/atom/static-1.5400",
      "client-types": "/client-types/static-1.498",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.9207",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.16304",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.13415",
      "conversations-message-history": "/conversations-message-history/static-1.13568",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.10817",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.24020",
      "data-fetching-client": "/data-fetching-client/static-1.9970",
      "head-dlb": "/head-dlb/static-1.5007",
      "hs-promise-utils": "/hs-promise-utils/static-1.5908",
      "hs-test-utils": "/hs-test-utils/static-1.8346",
      "hubspot-dlb": "/hubspot-dlb/static-2.1882",
      "HubStyleTokens": "/HubStyleTokens/static-2.11803",
      "I18n": "/I18n/static-7.1675",
      "immer": "/immer/static-1.101",
      "jasmine-immutable": "/jasmine-immutable/static-1.3335",
      "jasmine-runner": "/jasmine-runner/static-1.6765",
      "quartz": "/quartz/static-1.7472",
      "react-dlb": "/react-dlb/static-1.89",
      "react-select-plus": "/react-select-plus/static-1.113",
      "react-transition-group": "/react-transition-group/static-2.73",
      "redux-thunk": "/redux-thunk/static-2.80",
      "reselect": "/reselect/static-3.12",
      "sanitize": "/sanitize/static-1.4786",
      "StyleGuideUI": "/StyleGuideUI/static-3.503",
      "transmute": "/transmute/static-2.97",
      "urlinator": "/urlinator/static-1.4846",
      "usage-tracker": "/usage-tracker/static-1.7637",
      "usage-tracker-core": "/usage-tracker-core/static-1.7487",
      "usage-tracker-public": "/usage-tracker-public/static-1.7448",
      "viral-links-lib": "/viral-links-lib/static-1.7390",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6463",
      "webpack-env": "/webpack-env/static-1.54",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.5124",
      "conversations-prop-types": "/conversations-prop-types/static-1.7773",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.22757",
      "cssUtils": "/cssUtils/static-1.935",
      "enviro": "/enviro/static-4.455",
      "flux-actions": "/flux-actions/static-1.369",
      "foundations-components": "/foundations-components/static-1.8508",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.6528",
      "interactive-cards": "/interactive-cards/static-1.377",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
      "immutable": "/immutable/static-2.83",
      "metrics-js": "/metrics-js/static-1.9867",
      "PatternValidationJS": "/PatternValidationJS/static-1.3207",
      "PortalIdParser": "/PortalIdParser/static-2.404",
      "pulse": "/pulse/static-1.943",
      "raven": "/raven/static-3.5925",
      "react": "/react/static-7.196",
      "react-aria": "/react-aria/static-1.72",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.75",
      "react-rhumb": "/react-rhumb/static-1-fkhalid-fix-is-reload-in-web-vitals-adapter.6",
      "react-utils": "/react-utils/static-2.5563",
      "redux": "/redux/static-4.76",
      "rpc-client-utils": "/rpc-client-utils/static-1.4979",
      "redux-toolkit": "/redux-toolkit/static-1.78",
      "sanitize-text": "/sanitize-text/static-1.8469",
      "signup-constants": "/signup-constants/static-1.19642",
      "styled-components": "/styled-components/static-2.95",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.6051",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.6274",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
      "raven-hubspot": "/raven-hubspot/static-1.6232",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3628",
      "moment": "/moment/static-3.75",
      "quartz-config": "/quartz-config/static-1.1250",
      "quartz-core": "/quartz-core/static-1.6691",
      "foundations-assets": "/foundations-assets/static-1.5198",
      "foundations-theming": "/foundations-theming/static-1.4789",
      "UIComponents": "/UIComponents/static-3.8749",
      "conversations-async-data": "/conversations-async-data/static-2.7982",
      "customer-data-email": "/customer-data-email/static-1.18538",
      "cv-backend-services": "/cv-backend-services/static-1.1597",
      "immutable-less": "/immutable-less/static-1.4963",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7560",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.34079",
      "customer-data-objects": "/customer-data-objects/static-1.8006",
      "icons": "/icons/static-2.685",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.868",
      "ui-images": "/ui-images/static-2.1251",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "graphql": "/graphql/static-1.89",
      "HeadJS": "/HeadJS/static-2.798",
      "framer-motion": "/framer-motion/static-1.79",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3457",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.158",
      "i18n-data": "/i18n-data/static-1.229",
      "moment-timezone": "/moment-timezone/static-5.91",
      "jasmine": "/jasmine/static-4.4626",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8374",
      "HubStyle": "/HubStyle/static-2.12110",
      "quartz-i18n": "/quartz-i18n/static-1.1147",
      "sassPrefix": "/sassPrefix/static-1.205",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4777",
      "floating-ui": "/floating-ui/static-1.63",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2505",
      "hs-story-utils": "/hs-story-utils/static-1.9737",
      "react-create-root-preference": "/react-create-root-preference/static-1.72",
      "react-virtualized": "/react-virtualized/static-2.107",
      "tanstack-table": "/tanstack-table/static-1.61",
      "trellis-assets": "/trellis-assets/static-1.2671",
      "ui-fonts": "/ui-fonts/static-1.1065",
      "hs-locale-management": "/hs-locale-management/static-1.301",
      "dompurify": "/dompurify/static-1.8",
      "bend-plugin-pulse": "/bend-plugin-pulse/static-1.446",
      "batch-promise": "/batch-promise/static-1.1857",
      "chirp-fetch": "/chirp-fetch/static-1.2207",
      "event-emitter": "/event-emitter/static-1.1266",
      "fast-json-patch": "/fast-json-patch/static-1.70",
      "hub-http-janus": "/hub-http-janus/static-1.882",
      "quick-fetch": "/quick-fetch/static-1.4136",
      "csstype": "/csstype/static-1.50",
      "quartz-head": "/quartz-head/static-1.1137",
      "web-vitals": "/web-vitals/static-1.15",
      "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.389",
      "quartz-routing": "/quartz-routing/static-1.902",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6054",
      "bender-build-tools": "/bender-build-tools/static-1.3444",
      "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.85",
      "dispatcher": "/dispatcher/static-1.143",
      "general-store": "/general-store/static-6.20",
      "hubspotter-http": "/hubspotter-http/static-1.4870",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.578",
      "module-federation": "/module-federation/static-1.33",
      "opentelemetry-fe": "/opentelemetry-fe/static-1.460",
      "quartz-auth": "/quartz-auth/static-1.1147",
      "quartz-test": "/quartz-test/static-1.1147",
      "quartz-tracking": "/quartz-tracking/static-1.851",
      "trellis-components": "/trellis-components/static-1.2690",
      "usage-tracker-container": "/usage-tracker-container/static-1.7627",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3272",
      "foundations-theming-base": "/foundations-theming-base/static-1.3774",
      "stylex": "/stylex/static-1.41",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "apollo-dlb": "/apollo-dlb/static-3.86",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4969",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10143",
      "FileManagerCore": "/FileManagerCore/static-1.40017",
      "FileManagerLib": "/FileManagerLib/static-1.40158",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5190",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "salesImages": "/salesImages/static-1.576",
      "timezone-utils": "/timezone-utils/static-2.5557",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10625",
      "ts-schema": "/ts-schema/static-1.4301",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.9736",
      "avatar-components": "/avatar-components/static-1.2795",
      "content-assistance-lib": "/content-assistance-lib/static-1.8211",
      "crm-component-utils": "/crm-component-utils/static-1.39855",
      "crm-display-components": "/crm-display-components/static-1.25605",
      "crm-fe-perf": "/crm-fe-perf/static-1.23215",
      "crm-links": "/crm-links/static-1.6643",
      "crm-message-bus": "/crm-message-bus/static-1.43783",
      "crm-search-service-types": "/crm-search-service-types/static-1.1469",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5643",
      "customer-data-communicator": "/customer-data-communicator/static-1.46358",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40956",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13343",
      "customer-data-properties": "/customer-data-properties/static-1.52627",
      "customer-data-rte": "/customer-data-rte/static-1.33660",
      "draft-plugins": "/draft-plugins/static-2.22169",
      "file-manager-components": "/file-manager-components/static-1.24518",
      "trellis-theming": "/trellis-theming/static-1.1288",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7205",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.8235",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18985",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.11348",
      "prosemirror-user-and-team-at-mentions": "/prosemirror-user-and-team-at-mentions/static-1.1211",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8416",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18398",
      "universal-associations-select": "/universal-associations-select/static-1.11391",
      "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1978",
      "wootric-nps": "/wootric-nps/static-1.7207",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4062",
      "property-translator": "/property-translator/static-1.5709",
      "segments-query-core": "/segments-query-core/static-1.1737",
      "stylex-utils": "/stylex-utils/static-1.142",
      "opentelemetry-web": "/opentelemetry-web/static-1.13",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10634",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10632",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5323",
      "base-ui": "/base-ui/static-1.22",
      "react-day-picker": "/react-day-picker/static-1.10",
      "tanstack-virtual": "/tanstack-virtual/static-1.38",
      "react-dnd-compat": "/react-dnd-compat/static-1.4930",
      "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.368",
      "copilot-toolkit": "/copilot-toolkit/static-1.11861",
      "audio-components": "/audio-components/static-1.6356",
      "ContentUtils": "/ContentUtils/static-1.69138",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.29824",
      "FileManagerImages": "/FileManagerImages/static-1.37669",
      "html-to-image": "/html-to-image/static-1.61",
      "immerable": "/immerable/static-1.4461",
      "react-colorpicker": "/react-colorpicker/static-2.10530",
      "ui-universal-auth": "/ui-universal-auth/static-1.9422",
      "video-components": "/video-components/static-1.14163",
      "video-data-lib": "/video-data-lib/static-1.35819",
      "video-embed": "/video-embed/static-1.36653",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.649",
      "chatspot-core": "/chatspot-core/static-1.23068",
      "superstore": "/superstore/static-1.5071",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.9017",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.29323",
      "card-properties-lib": "/card-properties-lib/static-1.45027",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37798",
      "crm-actions": "/crm-actions/static-1.6664",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.44596",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9961",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.8414",
      "customer-data-tracking": "/customer-data-tracking/static-1.7196",
      "hs-resources": "/hs-resources/static-1.505",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
      "framework-data-table": "/framework-data-table/static-2.12565",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10114",
      "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1693",
      "calling-error-reporting": "/calling-error-reporting/static-1.31641",
      "calling-internal-common": "/calling-internal-common/static-1.31634",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6849",
      "crm_data": "/crm_data/static-4.92847",
      "customer-data-content": "/customer-data-content/static-1.27818",
      "draft-content-plugins": "/draft-content-plugins/static-1.28917",
      "draft-convert": "/draft-convert/static-2.80",
      "draft-extend": "/draft-extend/static-3.83",
      "draft-js": "/draft-js/static-5.85",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.24729",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25014",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18977",
      "integration-settings-components": "/integration-settings-components/static-1.16225",
      "integrations-lib": "/integrations-lib/static-1.17056",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5921",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8090",
      "nav-meta": "/nav-meta/static-1.30487",
      "onboarding-scopes": "/onboarding-scopes/static-1.6765",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.6828",
      "prosemirror": "/prosemirror/static-1.13",
      "prosemirror-copilot": "/prosemirror-copilot/static-1.12328",
      "quotes-client-types": "/quotes-client-types/static-1.38940",
      "reference-resolvers": "/reference-resolvers/static-1.8494",
      "rich-text-lib": "/rich-text-lib/static-1.20318",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4158",
      "sequences-lib": "/sequences-lib/static-1.8544",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11461",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9392",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.9402",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10584",
      "user-context": "/user-context/static-1.5433",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.6781",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23391",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13490",
      "events-data-lib": "/events-data-lib/static-1.559",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.5041",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4228",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1318",
      "onboarding-tours": "/onboarding-tours/static-1.17132",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14481",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.183",
      "ui-addon-teams": "/ui-addon-teams/static-1.21920",
      "calling-global-api": "/calling-global-api/static-1.65647",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67029",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59323",
      "commerce-products-lib": "/commerce-products-lib/static-1.10547",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4021",
      "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4554",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4355",
      "external-options-client-types": "/external-options-client-types/static-1.4345",
      "formula-editor": "/formula-editor/static-1.14781",
      "google-libphonenumber": "/google-libphonenumber/static-1.45",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4435",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.950",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3916",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.49696",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4189",
      "property-value-citations": "/property-value-citations/static-1.3241",
      "smart-data-capture-core": "/smart-data-capture-core/static-1.156",
      "smart-property-lib": "/smart-property-lib/static-1.8313",
      "tiered-pricing": "/tiered-pricing/static-1.1968",
      "topics-actions-lib": "/topics-actions-lib/static-1.480",
      "trial-components-library": "/trial-components-library/static-1.14119",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11295",
      "zustand": "/zustand/static-1.85",
      "breeze-engine-lib": "/breeze-engine-lib/static-1.1766",
      "video-components-external": "/video-components-external/static-1.12161",
      "fdsr-migration-layer": "/fdsr-migration-layer/static-1.324",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7110",
      "persist-promise": "/persist-promise/static-1.4014",
      "content-media-capture": "/content-media-capture/static-1.5457",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.26199",
      "knowledge-content-types": "/knowledge-content-types/static-1.8656",
      "payment-link-components": "/payment-link-components/static-1.24184",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10199",
      "call-summary": "/call-summary/static-1.40337",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10780",
      "laboratory-lib": "/laboratory-lib/static-3.7466",
      "merchandise-lib": "/merchandise-lib/static-1.278",
      "purchase-motions-components": "/purchase-motions-components/static-1.6378",
      "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10204",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "magpie-lib": "/magpie-lib/static-1.5765",
      "magpie-types": "/magpie-types/static-1.5225",
      "simple-logging-lib": "/simple-logging-lib/static-1.3364",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.1533",
      "cms-field-types": "/cms-field-types/static-1.5128",
      "content-icons-ui": "/content-icons-ui/static-1.2376",
      "underscore": "/underscore/static-1.8",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1218",
      "social-insights-client-types": "/social-insights-client-types/static-1.22706",
      "outpost": "/outpost/static-1.4467",
      "markdown-it": "/markdown-it/static-1.6",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6897",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.46752",
      "enrichment-lib": "/enrichment-lib/static-1.414",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4577",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.20204",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19235",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11059",
      "customer-data-associations": "/customer-data-associations/static-1.7640",
      "tasks-actions-lib": "/tasks-actions-lib/static-1.145",
      "reporting-data": "/reporting-data/static-1.68855",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.5074",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3793",
      "crm_universal": "/crm_universal/static-1.22508",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9633",
      "content-embed-lib": "/content-embed-lib/static-1.7650",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.13168",
      "remote-dom": "/remote-dom/static-1.4",
      "remote-ui": "/remote-ui/static-1.71",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5940",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.17905",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3322",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14471",
      "redux-observable": "/redux-observable/static-1.75",
      "ReduxMessenger": "/ReduxMessenger/static-2.10684",
      "rxjs": "/rxjs/static-5.10",
      "unified-auth": "/unified-auth/static-1.936",
      "messaging-types-lib": "/messaging-types-lib/static-1.46900",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.8948",
      "data-token-picker": "/data-token-picker/static-1.16902",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8401",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5991",
      "navigation-messaging": "/navigation-messaging/static-1.8177",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19258",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18376",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1199",
      "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.2025",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.7183",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.9940",
      "growth-data-modal": "/growth-data-modal/static-1.5909",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3374",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2703",
      "navigation-components": "/navigation-components/static-1.18850",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.5347",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7965",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.11355",
      "voice-sms-access-library": "/voice-sms-access-library/static-1.2078",
      "commerce-permissions": "/commerce-permissions/static-1.1091",
      "products-iframe-lib": "/products-iframe-lib/static-1.8607",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11016",
      "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6754",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10717",
      "sales-views-client-types": "/sales-views-client-types/static-1.4569",
      "bark-lib": "/bark-lib/static-1.16826",
      "browser-prettier": "/browser-prettier/static-1.11",
      "codemirror": "/codemirror/static-5.102",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6202",
      "react-codemirror": "/react-codemirror/static-1.10955",
      "data-agent-kit": "/data-agent-kit/static-1.662",
      "fsm": "/fsm/static-1.4064",
      "policy-lib": "/policy-lib/static-1.7115",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.15549",
      "hubs-service-types": "/hubs-service-types/static-1.1572",
      "purchase-motions-api": "/purchase-motions-api/static-1.6381",
      "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.744",
      "breeze-engine-core": "/breeze-engine-core/static-1.1044",
      "highlight.js": "/highlight.js/static-1.86",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13261",
      "content-media-compositions": "/content-media-compositions/static-2.17268",
      "idb-keyval": "/idb-keyval/static-1.51",
      "media-bridge-lib": "/media-bridge-lib/static-1.19419",
      "fix-webm-duration": "/fix-webm-duration/static-1.30",
      "notification-sounds": "/notification-sounds/static-1.4739",
      "seat-types-lib": "/seat-types-lib/static-1.747",
      "ui-addon-opt": "/ui-addon-opt/static-4.8677",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.6629",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5395",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3842",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.9397",
      "reactive-lib": "/reactive-lib/static-1.1031",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37997",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.13353",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55787",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22210",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18830",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72850",
      "data-agent-utils": "/data-agent-utils/static-1.476",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10292",
      "utility-belt": "/utility-belt/static-1.2846",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23866",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.8010",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6289",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.15573",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5418",
      "qrcode-generator": "/qrcode-generator/static-1.76",
      "reporting-client-types": "/reporting-client-types/static-1.2697",
      "react-flip-move": "/react-flip-move/static-1.78",
      "FireAlarmUi": "/FireAlarmUi/static-1.4729",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4391",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11411",
      "association-settings-lib": "/association-settings-lib/static-1.11031",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.58737",
      "conditional-property-settings-components": "/conditional-property-settings-components/static-1.261",
      "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.13172",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.13396",
      "ExportDialog": "/ExportDialog/static-6.10690",
      "final-form": "/final-form/static-1.78",
      "nudge-client-utils": "/nudge-client-utils/static-1.3155",
      "property-management-iframe": "/property-management-iframe/static-1.14145",
      "property-usages-lib": "/property-usages-lib/static-1.5817",
      "reactflow": "/reactflow/static-1.71",
      "simple-data-table": "/simple-data-table/static-1.3538",
      "used-in-list-lib": "/used-in-list-lib/static-1.7278",
      "visual-association": "/visual-association/static-1.6204",
      "highcharts": "/highcharts/static-8.111",
      "reporting-visualizations": "/reporting-visualizations/static-1.60930",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4232",
      "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.477",
      "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1444",
      "generic-oauth-auth-lib": "/generic-oauth-auth-lib/static-1.64",
      "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1044",
      "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.160",
      "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.503",
      "slack-ui-library": "/slack-ui-library/static-1.10712",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2663",
      "ContentData": "/ContentData/static-1.69213",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1293",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.2102",
      "ai-rendering-library": "/ai-rendering-library/static-1.11116",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8363",
      "breeze-engine-ui-devtools": "/breeze-engine-ui-devtools/static-1.140",
      "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1474",
      "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1644",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.578",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4229",
      "ui-tool-access": "/ui-tool-access/static-1.10468",
      "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2525",
      "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2731",
      "user-context-client": "/user-context-client/static-1.4819",
      "nest": "/nest/static-1.549",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36855",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16380",
      "browser-eslint": "/browser-eslint/static-2.57",
      "trellis-story-utils": "/trellis-story-utils/static-1.4821",
      "storybook-react": "/storybook-react/static-1.40",
      "academy-common-lib": "/academy-common-lib/static-1.15009",
      "js-cookie": "/js-cookie/static-1.18",
      "products-ui-components": "/products-ui-components/static-1.41065",
      "settings-ui-lib": "/settings-ui-lib/static-1.12838",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7550",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.55803",
      "commerce-products-api": "/commerce-products-api/static-1.2704",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57861",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.103528",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.81571",
      "one-click-checkout": "/one-click-checkout/static-1.431",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7900",
      "reporting-ui-components": "/reporting-ui-components/static-2.66125",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15252",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19282",
      "stripe-connect-js": "/stripe-connect-js/static-1.76",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9848",
      "hub-http-contrib": "/hub-http-contrib/static-1.3352",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5526",
      "nested-table": "/nested-table/static-1.547",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.23059",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3534",
      "conditional-property-settings-data": "/conditional-property-settings-data/static-1.279",
      "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2912",
      "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3231",
      "whisper-core-api": "/whisper-core-api/static-1.7340",
      "property-management-common": "/property-management-common/static-1.6433",
      "d3": "/d3/static-1.7",
      "advanced-menus-core": "/advanced-menus-core/static-1.15590",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.12464",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34859",
      "breeze-onboarding-components": "/breeze-onboarding-components/static-1.751",
      "global-styles-ai-lib": "/global-styles-ai-lib/static-1.154",
      "marketplace-embed-ba": "/marketplace-embed-ba/static-1.635",
      "mermaid": "/mermaid/static-1.3",
      "reporting-action-components": "/reporting-action-components/static-1.42066",
      "reporting-snowflake": "/reporting-snowflake/static-1.57472",
      "upgrade-components-lib": "/upgrade-components-lib/static-1.533",
      "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7922",
      "academy-service-client": "/academy-service-client/static-1.4002",
      "croppie": "/croppie/static-2.10",
      "SafeStorage": "/SafeStorage/static-1.4717",
      "trellis-ecosystem": "/trellis-ecosystem/static-1.7641",
      "commerce-tax-lib": "/commerce-tax-lib/static-1.852",
      "price-books-api": "/price-books-api/static-1.1750",
      "price-books-components": "/price-books-components/static-1.1808",
      "property-description-translator": "/property-description-translator/static-1.4152",
      "ramp-editor": "/ramp-editor/static-1.902",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3830",
      "totals-ui-components": "/totals-ui-components/static-1.24306",
      "checkout-sdk": "/checkout-sdk/static-3.24369",
      "payment-method-components": "/payment-method-components/static-1.7163",
      "touchless-buying-components": "/touchless-buying-components/static-1.6237",
      "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3783",
      "reporting-plugins": "/reporting-plugins/static-1.10768",
      "reporting-reports": "/reporting-reports/static-1.68532",
      "edison-service-client-types": "/edison-service-client-types/static-1.706",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10854",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18157",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.20750",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8340",
      "react-window": "/react-window/static-1.13",
      "ts-utils-lib": "/ts-utils-lib/static-1.463",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.15589",
      "simple-menus-lib": "/simple-menus-lib/static-1.17106",
      "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.932",
      "marketplace-embed": "/marketplace-embed/static-1.22932",
      "marketplace-ui-install": "/marketplace-ui-install/static-1.736",
      "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14920",
      "dashboard-lib": "/dashboard-lib/static-1.82867",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9021",
      "line-items-api": "/line-items-api/static-1.1108",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.4038",
      "hub-http-rxjs": "/hub-http-rxjs/static-1.846",
      "normalizr": "/normalizr/static-3.9",
      "ramda": "/ramda/static-1.7",
      "billing-payments-client-types": "/billing-payments-client-types/static-1.4304",
      "company-details-components": "/company-details-components/static-1.6517",
      "emoji-regex": "/emoji-regex/static-1.7",
      "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.15844",
      "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3768",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.10288",
      "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3531",
      "ui-addon-calendars": "/ui-addon-calendars/static-2.5647",
      "apps-service-types": "/apps-service-types/static-1.4053",
      "oauth-service-types": "/oauth-service-types/static-1.4549",
      "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1094",
      "connections-embed-lib": "/connections-embed-lib/static-1.1525",
      "fail-safe": "/fail-safe/static-1.267",
      "ai-studio-lib": "/ai-studio-lib/static-1.12450",
      "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.498",
      "ui-product-approvals": "/ui-product-approvals/static-1.29199",
      "redux-actions": "/redux-actions/static-3.70",
      "company-details-service-types": "/company-details-service-types/static-1.4253",
      "pricing-pages-api": "/pricing-pages-api/static-1.15709",
      "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.218"
    },
    "bundlingPackage": "conversations-visitor-ui",
    "bundlingPackageVersion": "static-1.30657",
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};